/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const bubble_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.75.75a10.485 10.485 0 0 0-8.916 16.025L.75 23.25l6.474-3.083A10.5 10.5 0 1 0 12.75.75v0Z"
    />
  </svg>
)
export default bubble_medium
